<template>
  <transition name="custom-fade">
    <div class="modal">
      <div class="modal-mask" @click="close"></div>
      <div class="modal-wrapper">
        <slot></slot>
      </div>
    </div>
  </transition>
</template>

<script>
// from https://vuejs.org/v2/examples/modal.html
export default {
  props: {
    lang: {
      type: Object,
      default () {
        return {
          close: 'close',
          commit: '确定'
        }
      }
    },
    showLogo: {
      type: Boolean,
      default: true
    },
    closeType: {
      type: String,
      default: 'default'
    },
    logoUrl: {
      type: String,
      default: 'http://az.cdn.nutsbp.com/007/image/nuts_dartcome/phone/pr/cut_page/pr_phone_logo.png'
    }
  },
  computed: {
    styleLogo () {
      return `background-image: url('${this.logoUrl}')`
    }
  },
  /**
   * @see https://stackoverflow.com/questions/9538868/prevent-body-from-scrolling-when-a-modal-is-opened
   */
  mounted () {
    document.body.style.overflow = 'hidden'
  },
  destroyed () {
    document.body.style.overflow = ''
  },
  methods: {
    close () { this.$emit('close') }
  }
}
</script>

<style lang="postcss" scoped>
.modal {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  & .modal-mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .8);
  }

  & .modal-wrapper {
    display: table;
    vertical-align: middle;
    width: inherit;
    height: inherit;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modal/BaseModal.vue